import qs from 'qs';
import { get } from 'lodash';
import { SURVEY_STATUS_ARCHIVED } from 'sharedParts';
import SurveyListSortableFields from '../../constants/surveyListSortableFields';
import SortOrder from '../../constants/sortOrder';
import getUrl from '../../utils/getUrl';

export const jsonApiFieldList = {
  survey: {
    include: 'items,preview',
    filter: {
      'items.hidden': false,
    },
  },
  surveyListItem: {
    include: 'creator,updater,preview',
    sort: `-${SurveyListSortableFields.CREATED_AT}`,
    fields: {
      survey:
        'name,id,created_at,updated_at,updated_by,status,answered_response_count,has_items,show_in_menu,slug,creator,updater',
      creator: 'name,id',
      updater: 'name,id',
    },
  },
  postSurveyLogic: {
    include: 'item',
    fields: {
      survey_item: 'id,item',
    },
  },
};

export const jsonApiHeaders = {
  Accept: 'application/vnd.api+json',
};

export const nocacheParameter = { r: Date.now() };

export const onlyCommonSurveysFilter = { type_: { eq: 'common' } };

export const addQueryParams = (baseUrl, params) => {
  const queryString = qs.stringify(params, {
    encode: false,
    skipNulls: true,
    arrayFormat: 'repeat',
  });

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const buildCrmApiUrl = (basePath, params) => addQueryParams(getUrl.crmApi(basePath), params);
export const buildCrmApiV3Url = (basePath, params) => addQueryParams(getUrl.crmApiV3(basePath), params);
export const buildApiUrl = (basePath, params) => addQueryParams(getUrl.api(basePath), params);
export const buildApiV2Url = (basePath, params) => addQueryParams(getUrl.apiV2(basePath), params);
export const buildApiV3Url = (basePath, params) => addQueryParams(getUrl.apiV3(basePath), params);
export const buildInternalV2ApiUrl = (basePath, params) =>
  addQueryParams(getUrl.internalV2Api(basePath), params);
export const buildAnalyticsUrl = (basePath, params) => addQueryParams(getUrl.analyticsUrl(basePath), params);

export const toSurveyListSearchFilter = (search) => {
  return (
    search && {
      name: {
        like: encodeURIComponent(`%${search.toLowerCase()}%`),
      },
    }
  );
};

export const toSurveyListStatusFilter = (statuses) => {
  if (!statuses || !statuses.length) {
    return {
      status: {
        neq: SURVEY_STATUS_ARCHIVED,
      },
    };
  }

  return (
    statuses &&
    statuses.length && {
      status: statuses,
    }
  );
};

export const toIsOnlyFavoriteFilter = (onlyFavorites = false) => ({
  only_favorites: onlyFavorites,
});

export const toSurveyListSortDirection = (sort, field) => {
  if (sort === SortOrder.ASCENDING) {
    return field;
  }

  if (sort === SortOrder.DESCENDING) {
    return `-${field}`;
  }
};

export const toSurveyImagesSearchFilter = (searchPhrase) => {
  return searchPhrase
    ? {
        display_name: {
          like: encodeURIComponent(`%${searchPhrase.toLowerCase()}%`),
        },
      }
    : null;
};

export const toTemplateListSearchFilter = (search) => {
  return (
    search && {
      name: {
        like: encodeURIComponent(`%${search.toLowerCase()}%`),
      },
    }
  );
};

export const toIsOnlyPlatformFilter = (onlyPlatform) => (onlyPlatform ? { type_: 'default_template' } : {});

export const toIsOnlyMyFilter = (onlyMy) => (onlyMy ? { type_: 'template' } : {});

export const getResponseStatus = (response) => get(response, 'response.status');

export const isUnautorizedRejection = (rejection) => getResponseStatus(rejection) === 401;

export const isForbiddenRejection = (rejection) => getResponseStatus(rejection) === 403;

export const getApiErrorList = (rejection) => get(rejection, 'rejection.response.data.errors', []);
